import apiCall from 'apps/investment/apiCalls/fund-econtracts';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, EditPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator, filterConfig } from './config';
import ItemDetail from './detail';
import ItemForm from './form';

export const FundEcontractsListPage = () => (
  <ListPage
    title="All Fund Econtracts"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={FilterForm}
  />
);

const FilterForm = () => {
  return <DynamicFilterForm fields={filterConfig} />;
};

export const FundEcontractsDetailPage = () => (
  <DetailPage
    title="Fund Econtract"
    apiCall={apiCall}
    listUrl={`/investment/fund-econtracts`}
    ItemDetail={ItemDetail}
    resourceName="data"
    options={{ editEnabled: true }}
  />
);

export const FundEcontractsEditPage = () => (
  <EditPage
    title="Fund Econtract"
    apiCall={apiCall}
    listUrl={`/investment/fund-econtracts`}
    ItemForm={ItemForm}
    resourceName="data"
  />
);
